type AnimationDirection = 'left' | 'right' | 'up' | 'down' | 'in' | 'out' | 'lightSpeedIn';

export const animationClass = (inView: boolean, direction: AnimationDirection) => {
    if (inView){
        return ' transition-all duration-1000 animate__animated ' + (
            direction === 'left' ? 'animate__fadeInLeft ' :
            direction === 'right' ? 'animate__fadeInRight ' :
            direction === 'up' ? 'animate__fadeInUp ' :
            direction === 'down' ? 'animate__fadeInDown ' :
            direction === 'in' ? 'animate__zoomIn' :
            direction === 'out' ?'animate__zoomOut' :
            "lightSpeedIn");
    } else {
        return ' transition-all duration-1000 opacity-0 ';
    }
}

export const animationStyle = (inView: boolean, direction: AnimationDirection, extraStyles = {}) => ({
  transform: inView ? 
          direction ==='in' || direction==='out' ? 'scale(1)' : 
          'translate(0, 0)' :  
          direction === 'left' ? 'translate(-50px, 0)' :
          direction === 'right' ? 'translate(50px, 0)' :
          direction === 'up' ? 'translate(0, 50px)' :
          direction === 'down' ? 'translate(0, -50px)' : 
          direction === 'in' ? 'scale3d(0.3, 0.3, 0.3)' :
          direction === 'lightSpeedIn' ? 'translate3d(100%, 0, 0) skewX(-30deg)' :
          'scale(1.5)' ,
  opacity: inView ? 1 : 0,
  transition: 'opacity 1s ease, transform 1s ease',
  ...extraStyles,
});